// SPDX-License-Identifier: AGPL-3.0-or-later

import UnicodeEmojis from '@app/features/expressions/utils/UnicodeEmojis';
import type {ReactionEmoji} from '@app/features/messaging/utils/ReactionUtils';

/** Original cute-ghost heart fill; also used for generic red hearts. */
export const DEFAULT_GHOST_HEART_COLOR = '#be1e2d';

const PINK_GHOST_HEART_COLOR = '#f4abba';

const COLORED_HEART_BY_SHORT_NAME: Record<string, string> = {
	heart: DEFAULT_GHOST_HEART_COLOR,
	red_heart: DEFAULT_GHOST_HEART_COLOR,
	orange_heart: '#f4900c',
	yellow_heart: '#fdcb58',
	green_heart: '#78b159',
	blue_heart: '#55acee',
	purple_heart: '#aa8ed6',
	brown_heart: '#c1694f',
	black_heart: '#31373d',
	white_heart: '#c5c6c8',
	pink_heart: PINK_GHOST_HEART_COLOR,
	light_blue_heart: '#88c9f9',
	grey_heart: '#8899a6',
	gray_heart: '#8899a6',
};

const PINK_HEART_SHORT_NAMES = new Set([
	'two_hearts',
	'sparkling_heart',
	'heartpulse',
	'heartbeat',
	'cupid',
	'gift_heart',
	'revolving_hearts',
	'hearts',
]);

export function heartColorForReaction(emoji: ReactionEmoji): string {
	if (emoji.id != null) return DEFAULT_GHOST_HEART_COLOR;
	const surrogate = UnicodeEmojis.normalizeEmojiNameToSurrogate(emoji.name);
	const shortName = (UnicodeEmojis.getSurrogateName(surrogate) ?? emoji.name).toLowerCase();
	return (
		COLORED_HEART_BY_SHORT_NAME[shortName] ??
		(PINK_HEART_SHORT_NAMES.has(shortName) ? PINK_GHOST_HEART_COLOR : DEFAULT_GHOST_HEART_COLOR)
	);
}
